var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#7E7E7E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33073 3.33268C5.56931 3.33268 3.33073 5.57126 3.33073 8.33268C3.33073 11.0941 5.56931 13.3327 8.33073 13.3327C11.0922 13.3327 13.3307 11.0941 13.3307 8.33268C13.3307 5.57126 11.0922 3.33268 8.33073 3.33268ZM1.66406 8.33268C1.66406 4.65078 4.64883 1.66602 8.33073 1.66602C12.0126 1.66602 14.9974 4.65078 14.9974 8.33268C14.9974 9.87327 14.4748 11.2918 13.5973 12.4207L18.0867 16.9101C18.4121 17.2355 18.4121 17.7632 18.0867 18.0886C17.7612 18.414 17.2336 18.414 16.9081 18.0886L12.4188 13.5992C11.2899 14.4768 9.87132 14.9993 8.33073 14.9993C4.64883 14.9993 1.66406 12.0146 1.66406 8.33268Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b3cb339971178b314ebbf3180e144cda.svg";
export { ForwardRef as ReactComponent };